import type { TRouteOptions } from '@casumo/fabric-fundamentals';
import { NATIVE_DEEP_LINK_SCHEME } from './constants';

export const getRouteAbsolutePrefix = (url: URL, options: TRouteOptions = {}) => {
    if (!options.absolute) {
        return '';
    }

    if (options.nativeDeepLink) {
        return NATIVE_DEEP_LINK_SCHEME;
    }

    return url.origin;
};
